export const HeadphonesIcon = () => (
  <svg id="headphones" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
    <path
      id="Fill"
      d="M28.032,33.967l-5.258-.686a1.669,1.669,0,0,1-1.507-1.855l1.971-13.013a1.753,1.753,0,0,1,2-1.4l5.343.7C30.2,8.279,24.263,5.1,17,5.1S3.8,8.279,3.42,17.713l5.343-.7a1.753,1.753,0,0,1,2,1.4l1.97,13.013a1.667,1.667,0,0,1-1.506,1.855l-5.258.686a3.5,3.5,0,0,1-4-2.8L.337,20.383q-.163-.808-.249-1.641L0,18.158l.039-.005Q0,17.581,0,17a17,17,0,0,1,34,0q0,.582-.039,1.155l.039.005-.088.583q-.085.832-.248,1.64L32.029,31.171A3.464,3.464,0,0,1,28.529,34,3.842,3.842,0,0,1,28.032,33.967Z"
      fill="#fff"
    />
  </svg>
)
